import { useEffect } from 'react';
import { observer } from 'mobx-react';

import { Title2, Text1 } from 'pages/Connection/components/Typography';
import RevenueCard from 'pages/Connection/components/RevenueCard';
import connectSources from 'store/ConnectSources';
import userStore from 'store/User';
import connectionStore from 'pages/Connection/components/connectionStore';
import accountConnect from 'pages/Connection/components/accountConnect';

import s from './styles.module.scss';

const ChooseRevenue = observer(() => {
  return (
    <div>
      <Title2 className={s.connectTitle}>Select your revenue sources</Title2>
      <div className={s.revenueCards}>
        {connectSources.sourcesListSelf.map((source) => {
          const { id, name, logo, code } = source;
          const onClick = () => {
            accountConnect.account = {
              id,
              name,
              logo,
              code,
            };
            connectionStore.currentScreen = 'connectAccount';
          };
          return <RevenueCard {...source} onClick={onClick} key={id} />;
        })}
      </div>
      <Text1>
        We are constantly updating the list of Revenue Source available
        <br />
        for connection. If your Revenue Source is not on the list above, we will
        <br />
        contact you.
      </Text1>
    </div>
  );
});

export default ChooseRevenue;
